import { BenefitModalAction } from './actions'
import { BenefitModalState } from './state'

export function benefitModalReducer(state: BenefitModalState, action: BenefitModalAction) {
  switch (action.type) {
    case 'OPEN_MODAL':
      // Currently only set to support one modal flow at a time
      if (!state.openModal) {
        return { ...state, openModal: action.payload }
      }
      return state
    case 'CLOSE_MODAL':
      if (state.openModal) {
        return { ...state, openModal: null }
      }
      return state
    default:
      return state
  }
}
